import request from './request';

export const connectUser = (data) =>
  request({
    method: 'post',
    url: '/api-token-auth/',
    data,
    newApi: false
  });

export const updateUser = (data) =>
  request({
    method: 'PATCH',
    url: '/api/v1/users/me/',
    data: data,
    protectedRoute: true,
    newApi: false
  });

export const resetUserPassword = (data) =>
  request({
    method: 'POST',
    url: `/password/reset/`,
    data,
    protectedRoute: true,
    newApi: false
  });
